import { openBlock as t, createElementBlock as e, createStaticVNode as c } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, a = /* @__PURE__ */ c('<path fill="#F0F0F0" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#FFDA44" d="M33.5 5.245A19.926 19.926 0 0 0 20 0c-.852 0-1.692.054-2.516.157L7.826 11.304.633 25.01a19.877 19.877 0 0 0 2.091 5.072L20 20 33.5 5.245Z"></path><path fill="#6DA544" d="m36.65 31.081-27.981 5.4A19.906 19.906 0 0 0 19.999 40c6.948 0 13.066-3.542 16.652-8.919Z"></path><path fill="#D80027" d="M33.503 5.248 2.736 30.1a20.075 20.075 0 0 0 2.866 3.779L40 20c0-5.84-2.504-11.096-6.497-14.752Z"></path><path fill="#0052B4" d="M0 20c0 1.73.22 3.41.633 5.01L17.484.157C7.626 1.394 0 9.807 0 20Z"></path>', 5), o = [
  a
];
function h(n, p) {
  return t(), e("svg", l, [...o]);
}
const i = { render: h };
export {
  i as default,
  h as render
};
